import Vue from 'vue';
import Component from 'vue-class-component';
import XTreeMenu from '../../components/left-navigation/XTreeMenu.vue';
import {XTreeItem} from '../../models/NavTreeModel';
import {getTreeChildren} from '../../models/NavTreeModel';



@Component({
    name:'modal-el',
  
    props:{

  },
    components:{
    
    }
})
export default class Modal extends Vue{

private visible:boolean = false;

      created(){
      
      }

      close(){
          this.$emit('close');
      }


}